export const volumes = [
  {
    numeral: "I",
    title: "The Foundation Protocol™",
    subtitle: "Start With a Clear Learning Pathway",
    intro:
      "Before organizing a large amount of information, it helps to establish a clear starting point. I've created this first volume to help you organize your introductory studies and establish a consistent learning framework.",
    items: [
      "A step-by-step guide to organizing your study materials",
      "A foundational biomagnetism glossary",
      "A learning preparation checklist",
      "A template for recording prior knowledge",
      "A concept organization worksheet",
      "A structured list of introductory topics",
      "A personal learning objectives sheet",
      "A guide to documenting questions for further study",
    ],
    result: "A clear starting point for organizing your biomagnetism learning journey.",
    color: "#9A5B3A",
  },
  {
    numeral: "II",
    title: "The Concept Mapping Protocol™",
    subtitle: "Turn Scattered Information Into Organized Visual Maps",
    intro:
      "When information is presented across different documents, it can be difficult to see how concepts relate to one another. This volume gives you ready-made visual tools to help organize what you're studying.",
    items: [
      "Concept map templates",
      "Visual learning diagrams",
      "Topic relationship worksheets",
      "Comparison tables",
      "Concept summary sheets",
      "A step-by-step concept mapping guide",
      "Review questions for each study section",
      "A checklist for completing your concept maps",
    ],
    result:
      "A visual system for organizing and reviewing introductory concepts without designing every resource yourself.",
    color: "#1F6B5E",
  },
  {
    numeral: "III",
    title: "The Reference Library Protocol™",
    subtitle: "Build Your Personal Biomagnetism Reference Library",
    intro:
      "I've created this volume to help you organize educational materials so you can find and review them more conveniently.",
    items: [
      "A ready-made topic index",
      "Reference sheet templates",
      "A source documentation worksheet",
      "A terminology organizer",
      "A study notes template",
      "A question tracking sheet",
      "A document organization checklist",
      "A reusable framework for organizing future learning resources",
    ],
    result: "A structured reference library that you can maintain as your knowledge develops.",
    color: "#2F5E8C",
  },
  {
    numeral: "IV",
    title: "The Active Review Protocol™",
    subtitle: "Follow a Structured Process to Review What You've Learned",
    intro:
      "Reading through your notes is only one way to study. This volume helps you organize review sessions using prepared educational resources.",
    items: [
      "Question and answer cards",
      "Concept review worksheets",
      "Vocabulary review templates",
      "Self-assessment questions",
      "A review session checklist",
      "A study progress tracker",
      "A learning reflection worksheet",
      "A template for recording topics that need further review",
    ],
    result:
      "A repeatable review process that helps you revisit information and identify areas where you need more study.",
    color: "#6B4FA0",
  },
  {
    numeral: "V",
    title: "The 30-Day Learning Roadmap™",
    subtitle: "Know What to Study, How to Organize It, and What to Review Next",
    intro:
      "This is the central planning component of the Protocol Vault. I've organized a 30-day roadmap to help you structure your learning activities without having to create your own calendar or decide on a new study plan every day.",
    items: [
      "A complete 30-day study calendar",
      "Weekly learning objectives",
      "Suggested study activities",
      "Daily planning sheets",
      "Review checkpoints",
      "Progress tracking worksheets",
      "A weekly reflection template",
      "A final learning review",
    ],
    result: "A structured plan you can follow at your own pace to organize your studies over 30 days.",
    note:
      "The roadmap is designed to organize your learning activities. It does not guarantee mastery, professional qualification, or clinical competence within 30 days.",
    color: "#B4473F",
  },
  {
    numeral: "VI",
    title: "The Knowledge Integration Protocol™",
    subtitle: "Keep Your Learning Organized as You Continue",
    intro:
      "Completing a study plan is only the beginning. I've created this final volume to help you maintain your personal learning system as you encounter new concepts and educational resources.",
    items: [
      "A personal knowledge index",
      "A reusable note-taking system",
      "A reference organization worksheet",
      "A monthly learning review",
      "A personal progress record",
      "A template for recording new questions",
      "A future learning objectives sheet",
      "A step-by-step guide to maintaining your study library",
    ],
    result: "A reusable system for organizing your learning beyond the initial 30-day roadmap.",
    color: "#5E7F5A",
  },
];
